import { AxiosResponse, AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyutyuHaisyaListGetReq,
  TZyutyuHaisyaListGetByIdReq,
  TZyutyuHaisyaListGetRes,
  TZyutuHaisyaPutReq,
  TZyutyuHaisyaMihaisyaListGetReq,
  TZyutyuHaisyaListDeleteReq,
  TZyutyuHaisyaPrintHaisyahyoReq,
  TZyutyuHaisyaETCKosokuryoPostReq,
  TZyutyuHaisyaETCKosokuryoPostRes,
} from "./TZyutyuHaisya"

/**
 * 受注配車入力に対するAPIリクエスト用サービス
 *
 * @export
 * @class zyutyuHaisyaService
 * @extends {ConnectApi}
 */
export default class ZyutyuHaisyaService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof zyutyuHaisyaService
   */
  getList = async (params: TZyutyuHaisyaListGetReq<any>) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaListGetRes[]>> =
        await this.postInner(`/order/zyutyuhaisya/actions/getlist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof zyutyuHaisyaService
   */
  getMihaisyaList = async (params: TZyutyuHaisyaMihaisyaListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaListGetRes[]>> =
        await this.postInner(`/order/zyutyuhaisya/actions/getlist`, {
          未配車フラグ: 1,
          ...params,
        })
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 受注配車IDによる検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof zyutyuHaisyaService
   */
  getListById = async (params: TZyutyuHaisyaListGetByIdReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaListGetRes[]>> =
        await this.postInner(`/order/zyutyuhaisya/actions/getlist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof zyutyuHaisyaService
   */
  get = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaListGetRes>> =
        await this.getInner(`/order/zyutyuhaisya/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 紐づけ済ETC高速料
   *
   * @param {TZyutuHaisyaPutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof zyutyuHaisyaService
   */
  getEtcKosokuryo = async (data: TZyutyuHaisyaETCKosokuryoPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaETCKosokuryoPostRes>> =
        await this.postInner(`/order/zyutyuhaisya/action/get/etcdata`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * グリッド登録
   *
   * @param {TMenuInfoGetReq} params
   * @memberof zyutyuHaisyaService
   */
  putList = async (params: TZyutyuHaisyaListGetRes[]) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaListGetRes[]>> =
        await this.putInner(`/order/zyutyuhaisya/upsertlist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 単体登録
   *
   * @param {TZyutuHaisyaPutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof zyutyuHaisyaService
   */
  post = async (data: TZyutuHaisyaPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/order/zyutyuhaisya`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TZyutuHaisyaPutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof zyutyuHaisyaService
   */
  put = async (id: string, data: TZyutuHaisyaPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/order/zyutyuhaisya/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   *
   * 特別手当取得（grid用）
   * @param {string} id
   * @param {TZyutyuHaisyaListGetRes} data
   * @memberof ZyutyuHaisyaService
   */
  get特別手当ByGrid = async (data: TZyutyuHaisyaListGetRes) => {
    try {
      const res: AxiosResponse<TApiResponse<number>> = await this.postInner(
        `/action/grid/gettokubetuteate`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * グリッド削除
   *
   * @param {TMenuInfoGetReq} params
   * @memberof zyutyuHaisyaService
   */
  deleteList = async (params: TZyutyuHaisyaListDeleteReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/order/zyutyuhaisya/deletelist`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {TMenuInfoGetReq} params
   * @memberof zyutyuHaisyaService
   */
  delete = async (param: TZyutyuHaisyaListDeleteReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/order/zyutyuhaisya/delete`,
        param
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 配車表印刷
   *
   * @param {TZyutyuHaisyaPrintHaisyahyoReq} params
   * @memberof zyutyuHaisyaService
   */
  printHaisyahyo = async (
    params: TZyutyuHaisyaPrintHaisyahyoReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G041102`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
